import { createColumnHelper } from '@tanstack/react-table'
import { ApplicantSources } from 'src/queries'

type TData = ApplicantSources[0]

const columnHelper = createColumnHelper<TData>()

const columns = [
  columnHelper.accessor('source', {
    header: 'Source'
  }),
  columnHelper.accessor('category.name', {
    id: 'category',
    header: 'Category'
  }),
  columnHelper.accessor('count', {
    header: 'Count'
  })
]

export { columns }
